import { Link } from 'react-router-dom';

export function AppLogo(): JSX.Element {
  return (
    <Link to="/repos" className="group flex items-center gap-2.5" aria-label="wt-codegraph home">
      <span
        className="grid h-8 w-8 place-items-center rounded-lg bg-gradient-to-br from-accent via-fuchsia-500 to-rose-500 text-base font-bold text-white shadow-glow transition-transform group-hover:scale-105"
        aria-hidden="true"
      >
        ◇
      </span>
      <span className="flex flex-col leading-tight">
        <span className="text-[15px] font-semibold tracking-tight">wt-codegraph</span>
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-text-muted">
          GraphRAG · CodeGraph
        </span>
      </span>
    </Link>
  );
}
